import React from 'react';
import { Switch, Route } from 'react-router-dom';
// Screens
import Login from './Login';
import ForgotPassword from './ForgotPassword';
import GeneratePassword from './GeneratePassword';
import Otp from './Otp';
import { Dialog } from '@material-ui/core';

import useWindowDimensions from '../../components/Dimension';

//Images
import Logo from '../../assets/logo.svg';
import Icon1 from '../../assets/megaphone.svg';
import Icon2 from '../../assets/plane.svg';
import Icon3 from '../../assets/calendar.svg';
import Icon4 from '../../assets/world.svg';
import Icon5 from '../../assets/diamond.svg';
import PlayIcon from '../../assets/play-sm.svg';
import CloseIcon from '@material-ui/icons/Close';

// Styles
import './styles.scss';

const LoginStack = () => {
  const [open, setOpen] = React.useState(false);
  //window height
  const { height } = useWindowDimensions();

  //Video Dialog Open
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="stack-wrapper" style={{ minHeight: height }}>
      <div className="login-stack-wrapper">
        <div className="static-info">
          <div className="logo-brand">
            <img src={Logo} alt="logo" />
          </div>
          <ul className="icon-list">
            <li>
              <span className="">
                <img src={Icon1} />
              </span>
              Analyse your Test Performance
            </li>
            <li>
              <span className="">
                <img src={Icon2} />
              </span>
              Get content from ALLEN Teachers online
            </li>
            <li>
              <span className="">
                <img src={Icon3} />
              </span>
              Meaningful insights to BOOST your score
            </li>
            <li>
              <span className="">
                <img src={Icon4} />
              </span>
              Stay up to date with Class Schedule & Exam
            </li>
            <li>
              <span className="">
                <img src={Icon5} />
              </span>
              See where you stand among ALLEN students
            </li>
          </ul>
        </div>
        <Switch>
          <Route exact path="/login" component={Login} />
          <Route path="/login/forgot-password" component={ForgotPassword} />
          <Route path="/login/generate-password" component={GeneratePassword} />
          <Route path="/login/verify-otp" component={Otp} />
        </Switch>
      </div>
      <div className="video-text">
        To understand the login procedure and walkthrough of ALLEN Digital
        Platform, Please watch this video
        <span className="link" onClick={handleClickOpen}>
          <span className="icon">
            <img src={PlayIcon} width="20" />
          </span>
          Play Now
        </span>
        {/* <div
          id="play-video"
          className="video-play-button"
          onClick={handleClickOpen}
        >
          <span>
            <img src={PlayIcon} />
          </span>
        </div> */}
      </div>

      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth={'sm'}
        className="simple-dialog"
      >
        <span className="popup-close" onClick={handleClose}>
          <CloseIcon />
        </span>
        <div className="embed-responsive embed-responsive-16by9">
          <iframe
            className="embed-responsive-item"
            width="100%"
            height="315"
            src="https://www.youtube.com/embed/_KQYI7hHlFk"
            frameBorder="0"
            allowFullScreen
          ></iframe>
        </div>
      </Dialog>
    </div>
  );
};

export default LoginStack;
